/* eslint-disable */

import { Collapsible } from './shared/webcomponents/collapsible';
import { ToggleElementClass } from './shared/webcomponents/toggle-element-class';
import { trapFocus, removeTrapFocus } from './shared/utils/focus';

class CollapsibleHeader extends Collapsible {
  constructor() {
    super();
    this.onShadowClick = this.closeAll.bind(this);
  }

  header() {
    return this.closest('[data-header]');
  }

  connectedCallback() {
    super.connectedCallback();

    const header = this.header();

    if (header) {
      this.shadow = header.querySelector('.header-shadow');
      this.shadow.addEventListener('click', this.onShadowClick, { signal: this.abortController.signal });
    }
  }

  events() {
    const header = this.header();

    if (!header) {
      super.events();
    }
  }

  open(group) {
    super.open(group);
    this.toggleHeaderClass(true);
  }

  close(group) {
    super.close(group);
    this.toggleHeaderClass(false);
  }

  closeSiblings(currentGroup = null) {
    super.closeSiblings(currentGroup);
    this.toggleHeaderClass(false);
  }

  openAll() {
    super.openAll();
    this.toggleHeaderClass(true);
  }

  closeAll() {
    super.closeAll();
    this.toggleHeaderClass(false);
  }

  toggleHeaderClass(open = true) {
    const header = this.header();

    if (!header) {
      return false;
    }

    if (open) {
      header.classList.add('header--is-open');
    } else {
      let close = true;
      this.groups.forEach((group) => {
        if (group.classList.contains(this.options.toggleClass)) {
          close = false;
        }
      });
      if (close) {
        header.classList.remove('header--is-open');
      }
    }
  }
}

class ToggleMobileNavigation extends ToggleElementClass {
  constructor() {
    super();
    this.onKeyUp = this.onKeyUp.bind(this);
    this.onShadowClick = this.remove.bind(this);
    this.onSearchInputKeyUp = this.onSearchInputKeyUp.bind(this);
    this.openSearchResults = this.openSearchResults.bind(this);
    this.searchValue = '';
  }

  body() {
    return document.querySelector('body');
  }

  header() {
    return document.querySelector('[data-header]');
  }

  connectedCallback() {
    super.connectedCallback();

    const header = this.header();

    if (header) {
      this.shadow = header.querySelector('.header-shadow');

      // iPhone fix
      if (navigator.userAgentData?.platform === 'iPhone') {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }

      // extra events
      document.addEventListener('keyup', this.onKeyUp, { signal: this.abortController.signal });
      this.shadow.addEventListener('click', this.onShadowClick, { signal: this.abortController.signal });
    }

    // listen for keyup event of search input
    const searchInput = document.querySelector('#Search-In-Modal');
    searchInput?.addEventListener('keyup', this.onSearchInputKeyUp, { signal: this.abortController.signal });

    const searchButton = document.querySelector('.search__button');
    searchButton?.addEventListener('click', this.openSearchResults, { signal: this.abortController.signal });
  }

  events() {
    const header = this.header();

    if (!header) {
      super.events();
    }
  }

  onKeyUp(event) {
    if (event.code?.toUpperCase() !== 'ESCAPE') {
      return;
    }

    const { toggleClass } = this.options;
    if (this.target?.classList.contains(toggleClass)) {
      this.remove();
    }
  }

  add() {
    super.add();
    const header = this.header();
    const body = this.body();
    if (body) {
      body.classList.add('header--is-active');
    }
    if (header) {
      header.classList.add('header--is-open');
      trapFocus(header);
    }
  }

  remove() {
    super.remove();
    const header = this.header();
    const body = this.body();
    if (header) {
      header.classList.remove('header--is-open');
    }
    if (body) {
      body.classList.remove('header--is-active');
    }
    this.closeAllSibblings();
    removeTrapFocus();
  }

  closeAllSibblings() {
    const collapsibles = this.target.querySelectorAll('collapsible-element');
    if (collapsibles.length > 0) {
      collapsibles.forEach((collapsible) => {
        if (typeof collapsible.closeAll === 'function') {
          collapsible.closeAll();
        }
      });
    }
  }

  onSearchInputKeyUp(event) {
    const eventCode = event.code;
    const inputValue = event.target.value;

    if (eventCode === 'Enter' && inputValue.length) {
      event.target.value = this.searchValue || inputValue;

      const locationOrigin = window.location.origin;
      const searchRedirectURL = `${locationOrigin}/search?view=results&q=${this.searchValue || inputValue}`;

      window.location.replace(searchRedirectURL);
    } else {
      this.searchValue = event.target.value;
    }
  }

  openSearchResults() {
    const inputValue = document.querySelector('#Search-In-Modal').value;

    const locationOrigin = window.location.origin;
    const searchRedirectURL = `${locationOrigin}/search?view=results&q=${inputValue}`;

    window.location.replace(searchRedirectURL);
  }
}

class ToggleSearch extends ToggleElementClass {
  constructor() {
    super();
    this.onKeyUp = this.onKeyUp.bind(this);
    this.onClickOutside = this.onClickOutside.bind(this);
    this.onCloseButtonClick = this.onCloseButtonClick.bind(this);
  }

  connectedCallback() {
    super.connectedCallback();
    const { signal } = this.abortController;

    // key up escape
    document.addEventListener('keyup', this.onKeyUp, { signal });

    // custom close button
    this.closeButton = this.target?.querySelector('[data-close-button]');
    this.closeButton?.addEventListener('click', this.onCloseButtonClick, { signal });

    // click outside search
    document.addEventListener('click', this.onClickOutside, { signal });
  }

  onKeyUp(event) {
    if (event.code?.toUpperCase() !== 'ESCAPE') {
      return;
    }
    const { toggleClass } = this.options;
    if (this.target?.classList.contains(toggleClass)) {
      this.remove();
    }
  }

  onCloseButtonClick(e) {
    e.preventDefault();
    e.stopPropagation();
    this.remove();
  }

  onClickOutside(e) {
    const { toggleClass, target } = this.options;
    if (this.target?.classList.contains(toggleClass)) {
      const isOutside = !e.target.closest(target);
      if (isOutside) {
        this.remove();
      }
    }
  }

  add() {
    super.add();
    if (this.target) {
      trapFocus(this.target);
    }
  }

  remove() {
    super.remove();
    removeTrapFocus();
  }
}

class TabNavigation extends HTMLElement {
  connectedCallback() {
    this.abortController = new AbortController();

    this.init();
  }

  init() {
    const { signal } = this.abortController;

    if (this.classList.contains('content-loaded') && !this.classList.contains('component-loaded')) {
      this.classList.add('component-loaded');
      this.tabs = this.querySelectorAll(
        '.category-tabs__list-nav li, .category-tabs__grid .category-tabs__item-holder'
      );
      this.asideTabs = this.querySelectorAll('.category-tabs__list-nav li');
      this.tabsContent = this.querySelectorAll('.tab-content .tab');
      this.categoryTabs = this.querySelector('.category-tabs__grid');
      this.tabsets = document.querySelectorAll('.tabset-on-hover li');
      this.tabContent = document.querySelectorAll('.header__tab-content .header-tab');
      this.tabs.forEach((tab) => {
        tab.addEventListener(
          'click',
          (e) => {
            e.preventDefault();
            const tabUrl = e.target.closest('.category-tabs__item-holder, .tabset__btn').getAttribute('href');

            this.categoryTabs.classList.add('hidden');
            this.hideAllTabContent(this.tabsContent);
            this.showTab(this.tabsContent, tabUrl);
            this.activeAsideTab(tabUrl);
          },
          { signal }
        );
      });

      document.querySelector('.tabset-on-hover').addEventListener('mouseover', this.headerTabs.bind(this), {
        signal,
      });
    }
  }

  disconnectedCallback() {
    this.abortController.abort();
  }

  removeAllActiveClasses(wrapper) {
    wrapper.forEach((tabset) => {
      tabset.classList.remove('active');
    });
  }

  setActiveTabset(tabUrl) {
    let activeTabSet = Array.from(this.tabsets).filter(
      (tabset) => tabset.querySelector('.tabset__btn').getAttribute('href') === tabUrl
    )[0];

    if (activeTabSet) {
      activeTabSet.classList.add('active');
    }
  }

  headerTabs(e) {
    let tabUrl = e.target.closest('.tabset__btn')?.getAttribute('href');

    this.removeAllActiveClasses(this.tabsets);
    this.setActiveTabset(tabUrl);
    this.hideAllTabContent(this.tabContent);
    this.showTab(this.tabContent, tabUrl);
  }

  activeAsideTab(tabUrl) {
    this.asideTabs.forEach((asideTab) => {
      const currentAsideTab = asideTab;

      currentAsideTab.classList.remove('active');

      if (currentAsideTab.querySelector('.tabset__btn').getAttribute('href') === tabUrl) {
        currentAsideTab.classList.add('active');
      }
    });
  }

  hideAllTabContent(wrapper) {
    wrapper.forEach((tab) => {
      tab.classList.remove('active');
      tab.classList.add('js-tab-hidden');
    });
  }

  showTab(wrapper, tabUrl) {
    if (tabUrl) {
      wrapper.forEach((tabContent) => {
        if (tabContent.getAttribute('id') == tabUrl?.split('#')[1]) {
          responseHelper({
            width: '1024..',
            on: () => {
              tabContent.classList.add('active');
              tabContent.classList.remove('js-tab-hidden');
            },
          });
        }
      });
    }
  }
}

if (!customElements.get('collapsible-header')) {
  customElements.define('collapsible-header', CollapsibleHeader);
}

if (!customElements.get('toggle-mobile-navigation')) {
  customElements.define('toggle-mobile-navigation', ToggleMobileNavigation);
}

if (!customElements.get('toggle-search')) {
  customElements.define('toggle-search', ToggleSearch);
}

if (!customElements.get('tab-navigation')) {
  customElements.define('tab-navigation', TabNavigation);
}

function setHeaderHeightVar() {
  const header = document.querySelector('.header');
  if (header) {
    const height = header.getBoundingClientRect().height;
    document.documentElement.style.setProperty('--top-header-height', `${height}px`);
  }
}

window.addEventListener('DOMContentLoaded', setHeaderHeightVar);
window.addEventListener('resize', setHeaderHeightVar);
